<template>
    <div class="container mb-3" data-aos="fade-up">
        <div class="row">
            <div class="col-8">
                <h2>FIAT PUNTO Attractive 1.4 (Flex) - 20/22</h2>
                <div id="myCarousel" class="carousel slide" data-bs-ride="carousel">
                    <div class="carousel-indicators">
                        <button type="button" data-bs-target="#myCarousel" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
                        <button type="button" data-bs-target="#myCarousel" data-bs-slide-to="1" aria-label="Slide 2"></button>
                        <button type="button" data-bs-target="#myCarousel" data-bs-slide-to="2" aria-label="Slide 3"></button>
                    </div>
                    <div class="carousel-inner">
                        <div class="carousel-item active">
                            <svg class="bd-placeholder-img" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" preserveAspectRatio="xMidYMid slice" focusable="false"><rect width="100%" height="100%" fill="#777"></rect></svg>
                            <div class="container">
                                <div class="carousel-caption text-start">
                                    <h1>Example headline.</h1>
                                    <p>Some representative placeholder content for the first slide of the carousel.</p>
                                    <p><a class="btn btn-lg btn-primary" href="#">Sign up today</a></p>
                                </div>
                            </div>
                        </div>
                        <div class="carousel-item">
                            <svg class="bd-placeholder-img" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" preserveAspectRatio="xMidYMid slice" focusable="false"><rect width="100%" height="100%" fill="#777"></rect></svg>
                            <div class="container">
                                <div class="carousel-caption">
                                    <h1>Another example headline.</h1>
                                    <p>Some representative placeholder content for the second slide of the carousel.</p>
                                    <p><a class="btn btn-lg btn-primary" href="#">Learn more</a></p>
                                </div>
                            </div>
                        </div>
                        <div class="carousel-item">
                            <svg class="bd-placeholder-img" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" preserveAspectRatio="xMidYMid slice" focusable="false"><rect width="100%" height="100%" fill="#777"></rect></svg>
                            <div class="container">
                                <div class="carousel-caption text-end">
                                    <h1>One more for good measure.</h1>
                                    <p>Some representative placeholder content for the third slide of this carousel.</p>
                                    <p><a class="btn btn-lg btn-primary" href="#">Browse gallery</a></p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <button class="carousel-control-prev" type="button" data-bs-target="#myCarousel" data-bs-slide="prev">
                        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span class="visually-hidden">Previous</span>
                    </button>
                    <button class="carousel-control-next" type="button" data-bs-target="#myCarousel" data-bs-slide="next">
                        <span class="carousel-control-next-icon" aria-hidden="true"></span>
                        <span class="visually-hidden">Next</span>
                    </button>
                </div>
                <div class="">
                    <h3>Caracteristicas</h3>
                    <ul class="list-unstyled flex-row row g-0 row-cols-2">
                        <li><i class="fa fa-road" aria-hidden="true"></i> 35,000 km</li>
                        <li><i class="fa fa-tachometer" aria-hidden="true"></i> 30.000 miles</li>
                        <li><i class="fa fa-calendar" aria-hidden="true"></i> 2005 model</li>
                        <li><i class="fa fa-car" aria-hidden="true"></i> Diesel</li>
                        <li><i class="fa fa-road" aria-hidden="true"></i> 35,000 km</li>
                        <li><i class="fa fa-tachometer" aria-hidden="true"></i> 30.000 miles</li>
                        <li><i class="fa fa-calendar" aria-hidden="true"></i> 2005 model</li>
                        <li><i class="fa fa-car" aria-hidden="true"></i> Diesel</li>
                    </ul>
                    <h3>Opcionais</h3>
                    <ul class="list-unstyled flex-row row g-0 row-cols-2">
                        <li><i class="fa fa-road" aria-hidden="true"></i> 35,000 km</li>
                        <li><i class="fa fa-tachometer" aria-hidden="true"></i> 30.000 miles</li>
                        <li><i class="fa fa-calendar" aria-hidden="true"></i> 2005 model</li>
                        <li><i class="fa fa-car" aria-hidden="true"></i> Diesel</li>
                        <li><i class="fa fa-road" aria-hidden="true"></i> 35,000 km</li>
                        <li><i class="fa fa-tachometer" aria-hidden="true"></i> 30.000 miles</li>
                        <li><i class="fa fa-calendar" aria-hidden="true"></i> 2005 model</li>
                        <li><i class="fa fa-car" aria-hidden="true"></i> Diesel</li>
                    </ul>
                </div>
            </div>
            <div class="col-4">
                <span class="text-primary fload-end fs-2 fw-bold">R$ 80.000,00</span>
                <ul class="list-inline">
                    <li class="facebook-icon"><a href="#"><i class="fa fa-facebook-square" aria-hidden="true"></i></a></li>
                    <li class="twitter-icon"><a href="#"><i class="fa fa-twitter-square" aria-hidden="true"></i></a></li>
                    <li class="linkedin-icon"><a href="#"><i class="fa fa-linkedin-square" aria-hidden="true"></i></a></li>
                    <li class="google-plus-icon"><a href="#"><i class="fa fa-google-plus-square" aria-hidden="true"></i></a></li>
                </ul>
            </div>
        </div>
    </div>
  </template>
  
  <script>
    
  </script>
  
  <style scoped>
  </style>
  